import { render, staticRenderFns } from "./HaberKategoriDetay.vue?vue&type=template&id=6667c8a6&scoped=true&"
import script from "./HaberKategoriDetay.vue?vue&type=script&lang=js&"
export * from "./HaberKategoriDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6667c8a6",
  null
  
)

export default component.exports